import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import './InsuranceEventSummary.scss';

export interface Row {
  dealerName: string;
  providerName: string;
  onlineApplications: number;
  inStoreApplications: number;
  textSent: number;
  textClick: number;
  textConverted: number;
}

interface Props {
  rows: Row[];
}

export function SummaryTable({ rows }: Props) {
  return (
    <div>
      <BootstrapTable
        pagination
        striped
        tableStyle={{ border: 'none' }}
        data={rows}
      >
        <TableHeaderColumn
          isKey
          dataField="dealerName"
          className="table-header"
        >
          Dealership Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="providerName"
          className="table-header"
          dataSort
        >
          Provider
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="onlineApplications"
          className="table-header"
          dataSort
        >
          Online
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="inStoreApplications"
          className="table-header"
          dataSort
        >
          Instore
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="textSent"
          className="table-header"
          dataSort
        >
          Texts sent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="textClick"
          className="table-header"
          dataSort
        >
          Text clickthroughs
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="textConverted"
          className="table-header"
          dataSort
        >
          Text leads converted
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}
